/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React, { FC, useState } from "react";

import { Button, Icon, SheetContainer, Text } from "@bookingcom/bui-react";
import { I18nChildContext, t, useI18n } from "@bookingcom/lingojs-react";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline/index.js";
import flights_merch_toolkit_offer_pinning_guardrail_v1 from "../../../../../utils/experiments/genius/flights_merch_toolkit_offer_pinning_guardrail_v1";
import type { HighlightInfoTooltip } from "./types";
import styles from "./FlightCardGeniusHighlightBottomSheetWrapper.module.css";

type Props = {
  infoTooltip: HighlightInfoTooltip;
};

const FlightCardGeniusHighlightBottomSheetWrapper: FC<Props> = ({ infoTooltip }) => {
  const i18n = useI18n() as I18nChildContext;
  const [isBottomSheetActive, setBottomSheetActive] = useState(false);

  return (
    <>
      <Button
        variant="tertiary"
        className={styles.geniusHighlightBottomSheetButton}
        attributes={{
          "aria-label": infoTooltip.ariaLabel,
          onClick: (event: React.MouseEvent) => {
            event.stopPropagation();
            event.preventDefault();
            setBottomSheetActive(true);
          }
        }}
      >
        <Icon size="medium" svg={InfoSignIcon} />
      </Button>

      <SheetContainer
        active={isBottomSheetActive}
        onCloseTrigger={() => setBottomSheetActive(false)}
        closeAriaLabel={i18n.trans(t("a11y_flights_sr_genius_pinned_deal_close_popup"))}
        position="bottom"
        title={infoTooltip.title ?? ""}
        onOpen={async () => {
          flights_merch_toolkit_offer_pinning_guardrail_v1.goals.featured_info_displayed();
        }}
      >
        <Text>{infoTooltip.content}</Text>
      </SheetContainer>
    </>
  );
};

export default FlightCardGeniusHighlightBottomSheetWrapper;
